module.exports = __webpack_public_path__ + "img/logo.b6df273d.png";